export default __webpack_public_path__ + "themes/slashy.css";